/* eslint-disable max-len */
/* eslint-disable no-param-reassign */
// Class that represents the data of this store

import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { CustomAttributeValue, CustomAttributeValueDTO, toDTO } from '../../common/libraries/customAttributes/customAttributeValue';

// Class that represents the data of this store

class CustomAttributesReducerData {
  customAttributesValues : CustomAttributeValueDTO[] = [];
}

// Initial State

const initialState : CustomAttributesReducerData = {
  customAttributesValues: [],
};

// Store definition
// This reducer will manage the custom attributes values for a particular order.
// We need to to store them here, because they should persist until the order is submitted.

export const CustomAttributesReducer = createSlice({

  name: 'CustomAttributesReducer',

  initialState,

  reducers: {
    setAttributeValue: {
      reducer: (state, action: PayloadAction<CustomAttributeValueDTO>) => {
        const other = state.customAttributesValues.filter((a) => a.attributeKey !== action.payload.attributeKey);
        state.customAttributesValues = [...other, action.payload];
      },
      prepare: (value: CustomAttributeValue | CustomAttributeValueDTO) => {
        const payload = value instanceof CustomAttributeValue ? toDTO(value) : value;
        return { payload };
      },
    },
    setAllAttributeValues: {
      reducer: (state, action: PayloadAction<CustomAttributeValueDTO[]>) => {
        state.customAttributesValues = [...action.payload];
      },
      prepare: (values: (CustomAttributeValue | CustomAttributeValueDTO)[]) => {
        const payload = values.map((v) => (v instanceof CustomAttributeValue ? toDTO(v) : v));
        return { payload };
      },
    },

    clearAttributes: (state) => {
      state.customAttributesValues = [];
    },
  },
});
